import { BaseText, type BaseTextProps } from "~/components/layout/text/BaseText";
import { Flex } from "~/constants/layout";

export const BodyText = ({ lineBreakStrategyIOS = "standard", children, ...textProps }: BaseTextProps) => {
    return (
        <BaseText {...textProps} style={[Flex.shrink, textProps.style]} lineBreakStrategyIOS={lineBreakStrategyIOS}>
            {children}
        </BaseText>
    );
};
